<template>
  <div class="international-pay-title-component">
    <div class="info"></div>
    <div class="order-info">
      <span>{{TS('Grand_Total')}}：<span class="price">HKD {{order.payOrderView.totalPrice}}</span>，</span>
      <span>{{TS('Order_Number')}}：<span class="price">{{order.payOrderView.serialNumber}}</span></span>
    </div>

  </div>
</template>

<script>
import { I18n } from '../config'
export default {
  props: {
    order: {
      type: Object,
      default: () => {
        return {}
      }
    },
    i18n: {
      type: String,
      default: ''
    }
  },
  components: {

  },
  data() {
    return {

    }
  },
  created() {

  },
  methods: {
    TS(key) {
      return I18n(this.i18n, key)
    },
  }
}
</script>

<style lang="scss" scoped>
.international-pay-title-component {
  margin-top: 20px;
  margin-bottom: 20px;
  .order-info {
    background-color: #f9f9f9;
    height: 44px;
    line-height: 44px;
    padding: 0 10px;
    span {
      &.price {
        color: #f85415;
      }
    }
  }
}
</style>
